import { render, staticRenderFns } from "./ZFFormItem.vue?vue&type=template&id=c5fa72d2"
import script from "./ZFFormItem.vue?vue&type=script&lang=js"
export * from "./ZFFormItem.vue?vue&type=script&lang=js"
import style0 from "./ZFFormItem.vue?vue&type=style&index=0&id=c5fa72d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports